import React from "react";
import { Outlet } from "react-router-dom";
import { ComplaintFiltersProvider } from "../../Contexts/ComplaintFiltersContext";

/**
 * Wrapper component to maintain ComplaintFilters context across complaint-related routes
 * This ensures filter states persist when navigating between AllComplaints and ComplaintDetails
 */
const ComplaintsWrapper = () => {
  return (
    <ComplaintFiltersProvider>
      <Outlet />
    </ComplaintFiltersProvider>
  );
};

export default ComplaintsWrapper;

